export default __webpack_public_path__ + "static/fall32-edd24054f14c1c6ac65512c1370d3156.webp";